import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const newsApiKey = "5f66fa63895342edbcab89487c2b9157"; // Replace with your NewsAPI key
const baseUrl = "https://newsapi.org/v2";

export const cryptoNewsApi = createApi({
  reducerPath: "cryptoNewsApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Authorization", newsApiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCryptoNews: builder.query({
      query: ({ newsCategory, count }) =>
        `/everything?q=${encodeURIComponent(newsCategory)}&pageSize=${count}&language=en`,
    }),
  }),
});

export const { useGetCryptoNewsQuery } = cryptoNewsApi;
